import type { ClientPortalBillingSummary } from './clientPortalFhirTypes';

export type BillingPageContent = 'loading' | 'error' | 'unavailable' | 'chrome';

/**
 * Choose Billing page chrome vs fallbacks.
 * A successful empty summary (zeros / empty arrays) is still `chrome` so
 * balance + tabs + per-tab empty states render.
 */
export function resolveBillingPageContent(input: {
  loading: boolean;
  error: string | null;
  summary: ClientPortalBillingSummary | null;
}): BillingPageContent {
  if (input.loading) return 'loading';
  if (input.error) return 'error';
  if (!input.summary) return 'unavailable';
  return 'chrome';
}
